// extracted by mini-css-extract-plugin
export default {"pagination":"styles_pagination__QXDtE","elipsis":"styles_elipsis__yqzdX","item":"styles_item__U9fHN","arrow":"styles_arrow__Y8acB","active":"styles_active__VEoGp"};